module.exports = __webpack_public_path__ + "static/media/menu_preAdvise_default.51e6d5de.svg";